import React, { useState } from "react";
import { toast } from "sonner";
import { cvApi, cvErr } from "@/lib/vendorApi";
import { inputCls, goldBtn } from "@/pages/partner/PartnerLoginPage";

const F = ({ label, children }) => <label className="block text-sm text-white/70 space-y-1"><span>{label}</span>{children}</label>;

/** First sign-in: the vendor adds their business details (creates their Finance vendor record). */
export function VendorOnboard({ me, onDone }) {
  const [f, setF] = useState({ company: me.vendor.company || "", contact_name: me.vendor.name || "", phone: "", email: me.vendor.email || "", address: "", payment_method: "check", tax_id: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { onDone(await cvApi.post("/onboard", f)); toast.success("Business details saved"); } catch (err) { toast.error(cvErr(err)); } finally { setBusy(false); }
  };
  const inp = (k, props = {}) => <input data-testid={`vendor-onboard-${k}`} value={f[k]} onChange={set(k)} className={inputCls} {...props} />;
  return (
    <form onSubmit={save} className="space-y-4 max-w-xl" data-testid="vendor-onboard">
      <div><h2 className="text-2xl font-semibold">Welcome — tell us about your business</h2>
        <p className="text-sm text-white/50 mt-1">One time only. This sets you up for invoices and payments with The Exchange Alliance.</p></div>
      <F label="Company name">{inp("company")}</F>
      <F label="Your name">{inp("contact_name")}</F>
      <div className="grid sm:grid-cols-2 gap-3"><F label="Mobile number">{inp("phone", { type: "tel", placeholder: "(843) 555-0123" })}</F><F label="Email">{inp("email", { type: "email" })}</F></div>
      <F label="Business address">{inp("address")}</F>
      <div className="grid sm:grid-cols-2 gap-3">
        <F label="How you get paid"><select data-testid="vendor-onboard-payment_method" value={f.payment_method} onChange={set("payment_method")} className={inputCls}>
          <option value="check">Check</option><option value="ach">ACH (bank transfer)</option><option value="wire">Wire</option></select></F>
        <F label="EIN / tax ID (optional)">{inp("tax_id")}</F>
      </div>
      <button type="submit" disabled={busy || !f.company.trim() || !f.contact_name.trim() || !f.phone.trim() || !f.email.trim() || f.address.trim().length < 3} data-testid="vendor-onboard-save" className={goldBtn}>Save and continue</button>
    </form>
  );
}
